import { Grid, useTheme } from "@mui/material";
import { KpiCard } from "../../programmeDashboard/components/KpiCard";

interface KpiData {
    label: string;
    value: string;
    subValue: string;
    icon?: React.ReactNode;
}

const kpiData: KpiData[] = [
    {
        label: 'EAC Movement',
        value: '£29,820,000',
        subValue: '£420,000 (+1.4%) vs previous snapshot',
    },
    {
        label: 'Commitments Movement',
        value: '£28,330,000',
        subValue: '£130,000 (+0.5%) vs previous snapshot',
    },
    {
        label: 'Actuals Movement',
        value: '£18,750,000',
        subValue: '£250,000 (+1.4%) vs previous snapshot',
    }
];

export const MovementKpiCards = () => {
    const theme = useTheme();

    return (
        <Grid container spacing={2} sx={{ mb: 3 }} px={2}>
            {kpiData.map((item) => (
                <Grid size={{ xs: 12, sm: 6, md: 4 }} key={item.label}>
                    <KpiCard
                        label={item.label}
                        value={item.value}
                        icon={item.icon}
                        iconColor={theme.palette.info.main}
                        subValue={item.subValue}
                    />
                </Grid>
            ))}
        </Grid>
    );
};
